let DEFAULT_SETTINGS = {

	blockSize: 36,
	moveSpeed: 300

}

export {

	DEFAULT_SETTINGS

};